<script type="text/javascript">
	import Button from '@smui/button';
	import AuthStore from "../Auth/Store";
	import Feature from "../Branding/Feature";
	import User from "../Branding/User";
	import LoadState from "../Enums/LoadState";
	import MapStore from "../Map/Store";
	import Error from "../UI/Error/Error.svelte";
	import ModalWindow from "../UI/ModalWindow.svelte";
	import Spinner from "../UI/Spinner/Spinner.svelte";
	import SpinnerSize from "../UI/Spinner/SpinnerSize";
	import ShippingLanesFiltersStore from "./ShippingLaneFilter/Store";
	import "./ShippingLanes.scss";
	import ShippingLaneSetView from './ShippingLaneSetView/ShippingLaneSetView.svelte';
	import ShippingLanesSet from "./ShippingLanesSet";
	import ShippingLanesSetType from "./ShippingLanesSetType";
	import ShippingLanesStore from "./Store";

	let lastUpdated = ShippingLanesStore.lastUpdated;
	let visible = ShippingLanesStore.visible;
	let initialised = false;
	let error = false;
	let filterLoadState = ShippingLanesFiltersStore.meta.loadState;

	MapStore.meta.initialised.subscribe((initted)=>{
		if (initted && User.hasFeature(Feature.SHIPPING_LANES.VIEW)) {
			ShippingLanesStore.init();
		}
	});

	let sets = ShippingLanesStore.sets;

	$: {
		initialised = ($filterLoadState === LoadState.LOADED);
		error = ($filterLoadState === LoadState.ERROR);
	}

	$: {
		sets = ShippingLanesStore.sets;
		$lastUpdated = $lastUpdated;
	}
	$: {
		$visible;
		ShippingLanesStore.update();
	}

	let addSet = () => {
		const set = new ShippingLanesSet();
		ShippingLanesStore.update();
	};


	let user = AuthStore.session.user;
	let availableSets = [];
	$: {
		$user;
		let updatedSets = [];
		updatedSets.push(ShippingLanesSetType.SHIPPING);
		if (User.hasFeature(Feature.SHIPPING_LANES.FISHING.VIEW)) {
			updatedSets.push(ShippingLanesSetType.FISHING);
		}
		if (User.hasFeature(Feature.SHIPPING_LANES.FISHING_TRAWLERS.VIEW)) {
			updatedSets.push(ShippingLanesSetType.TRAWLING);
		}
		if (User.hasFeature(Feature.SHIPPING_LANES.DARK.VIEW)) {
			updatedSets.push(ShippingLanesSetType.DARK);
		}
		availableSets = updatedSets;
	}

</script>

<ModalWindow
	title={`Shipping Lanes`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible}
	>
	<div id='shipping-lanes-queries'>
		{#if (!initialised && !error)}
			<p style="text-align:center; margin:0px; height:8rem;">
				<Spinner size={SpinnerSize.NORMAL} absolute={false} inline={true} />
			</p>
		{:else if error}
			<Error />
		{:else}
			{#each sets as set, index}
				<ShippingLaneSetView set={set} index={index} availableSets={availableSets}/>
			{/each}
			<Button color="primary" variant="unelevated" class="btn-add" on:click={()=>{ addSet(); }}>Add</Button>

		{/if}

	</div>
</ModalWindow>
